import { jsonb, pgEnum, timestamp } from "drizzle-orm/pg-core";
import { createSelectSchema } from "drizzle-zod";
import z from "zod";

export const timestamps = {
  createdAt: timestamp().$defaultFn(() => /* @__PURE__ */ new Date()),
  updatedAt: timestamp()
    .$defaultFn(() => /* @__PURE__ */ new Date())
    .$onUpdateFn(() => new Date()),
};

export type LexicalState = {
  root: {
    children: Array<any>;
    direction: "ltr" | "rtl" | null;
    format: "" | "left" | "start" | "center" | "right" | "end" | "justify" | "";
    indent: number;
    type: "root";
    version: number;
  };
};

export function richText() {
  return jsonb().$type<LexicalState>();
}

export const lexicalStateSchema: z.ZodType<LexicalState> = z.object({
  root: z.object({
    children: z.array(z.any()),
    direction: z.enum(["ltr", "rtl"]).nullable(),
    format: z.enum(["", "left", "start", "center", "right", "end", "justify"]),
    indent: z.number(),
    type: z.literal("root"),
    version: z.number(),
  }),
});

// "unknown" exists only for anonymized (deleted) player profiles — gender is
// personal information and is erased, but the column is NOT NULL. No UI offers
// it and no division or team should ever hold it.
export const genderEnum = pgEnum("gender", [
  "male",
  "female",
  "coed",
  "unknown",
]);

export const genderSchema = createSelectSchema(genderEnum);

export type Gender = z.infer<typeof genderSchema>;

export const rightLeftEnum = pgEnum("right_left", ["right", "left"]);

export const playerRoleEnum = pgEnum("player_role", ["blocker", "defender"]);

export const tournamentStatusEnum = pgEnum("tournament_status", [
  "closed",
  "running",
  "paused",
  "complete",
  "cancelled",
]);

export const teamStatusEnum = pgEnum("team_status", [
  "registered",
  "waitlisted",
  "confirmed",
  "cancelled",
  "withdraw",
  "late-withdraw",
  "voided",
  "transferred",
]);

export const teamStatusSchema = createSelectSchema(teamStatusEnum);

export type TeamStatus = z.infer<typeof teamStatusSchema>;

export const venueStatusEnum = pgEnum("venue_status", [
  "active",
  "hidden",
  "legacy",
]);

export const matchStatusEnum = pgEnum("match_status", [
  "scheduled",
  "in_progress",
  "completed",
  "cancelled",
]);

export const matchStatusSchema = createSelectSchema(matchStatusEnum);

export type MatchStatus = z.infer<typeof matchStatusSchema>;

export const setStatusEnum = pgEnum("set_status", [
  "not_started",
  "in_progress",
  "completed",
]);

export const scoreTeamEnum = pgEnum("score_team", ["A", "B"]);

export const collegeCommitmentLevelEnum = pgEnum("college_commitment_level", [
  "uncommitted",
  "verbal_commit",
  "signed",
]);
